import { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import MainNav from './MainNav';
import './MobileNotice.css';

const TRANSLATIONS = {
  en: {
    subtitle: 'K-Beauty Market Intelligence',
    title: 'Desktop Only',
    message: 'This service is available on desktop browsers only. Please access it from a desktop device to use all features.',
  },
  ko: {
    subtitle: 'K-뷰티 마켓 인텔리전스',
    title: '데스크톱 전용',
    message: '이 서비스는 데스크톱 브라우저에서만 이용 가능합니다. 모든 기능을 사용하시려면 데스크톱에서 접속해주세요.',
  },
  vi: {
    subtitle: 'K-Beauty Market Intelligence',
    title: 'Chi dành cho máy tính',
    message: 'Dịch vụ này chỉ khả dụng trên trình duyệt máy tính. Vui lòng truy cập từ máy tính để sử dụng đầy đủ tính năng.',
  },
};

const MOBILE_BREAKPOINT = 800;

const MobileNotice = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const { language } = useLanguage();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!isMobile) return children;

  const t = TRANSLATIONS[language] || TRANSLATIONS.en;

  return (
    <div className="mobile-notice">
      <MainNav />
      <div className="mobile-notice__body">
        <div className="mobile-notice__card">
          <div className="mobile-notice__brand">
            <img src="/logo.webp" alt="K-B Logo" className="mobile-notice__logo" />
            <span className="mobile-notice__brand-name">Insight</span>
          </div>
          <p className="mobile-notice__subtitle">{t.subtitle}</p>
          <div className="mobile-notice__divider" />
          <div className="mobile-notice__icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="8" y="6" width="32" height="24" rx="2" stroke="currentColor" strokeWidth="2.5" fill="none" />
              <rect x="12" y="10" width="24" height="16" rx="1" fill="currentColor" opacity="0.1" />
              <path d="M16 36h16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <path d="M20 30v6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <path d="M28 30v6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
          <h1 className="mobile-notice__title">{t.title}</h1>
          <p className="mobile-notice__message">{t.message}</p>
        </div>
      </div>
    </div>
  );
};

export default MobileNotice;
